<script setup lang="ts">
import { RouterView } from 'vue-router'

import AlertMessage from '@/components/common/ui/overlays/AlertMessage.vue'
import SimpleNotification from '@/components/common/ui/overlays/SimpleNotification.vue'
import DataViewTypeProvider from '@/components/contextProviders/DataViewTypeProvider.vue'
import CreateRelationSlideIn from '@/components/createRelationGroup/CreateRelationSlideIn.vue'
import { AlertType } from '@/constants/ui'
import ModalBase from '@/overlays/ModalBase.vue'
import { useAlertManagerStore } from '@/stores/alertManager.ts'
import { useModalManagerStore } from '@/stores/modalManager.ts'
import { useThemeStore } from '@/stores/themeStore.ts'

const modalStore = useModalManagerStore()
const alertStore = useAlertManagerStore()
// Applies the UI theme to <html> and keeps the Frappe iframes in sync.
useThemeStore()

const handleModalDelete = (): void => {
  if (modalStore.onDelete) {
    modalStore.onDelete()
  }
}
</script>

<template>
  <DataViewTypeProvider>
    <RouterView />
  </DataViewTypeProvider>
  <ModalBase
    v-if="modalStore.modalVisible && modalStore.modalComponent"
    :open="modalStore.modalVisible"
    :show-delete="!!modalStore.onDelete"
    :title="modalStore.modalTitle"
    @on-close="modalStore.closeModal"
    @on-delete="handleModalDelete"
  >
    <component :is="modalStore.modalComponent" v-bind="modalStore.modalProps" />
  </ModalBase>
  <AlertMessage
    v-if="alertStore.alertVisible"
    :alert-type="alertStore.alertType ?? AlertType.warning"
    :cancel-label="alertStore.cancelLabel"
    :cta-label="alertStore.ctaLabel"
    :loading="alertStore.loading"
    :message="alertStore.message"
    :message-title="alertStore.messageTitle"
    :open="alertStore.alertVisible"
    @on-close="alertStore.closeAlert"
    @on-cta-click="alertStore.submitAlert"
  />
  <CreateRelationSlideIn />
  <SimpleNotification />
</template>
